module.exports = __webpack_public_path__ + "static/media/FolderUpdatesEmpty.9a6c590d.png";